(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionStateHistoryDetailController', HandbookVersionStateHistoryDetailController);

    HandbookVersionStateHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookVersionStateHistory', 'HandbookVersion', 'CustomUser'];

    function HandbookVersionStateHistoryDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookVersionStateHistory, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbookVersionStateHistory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookVersionStateHistoryUpdate', function(event, result) {
            vm.handbookVersionStateHistory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
